<template>
  <Component :is="tag" :class="rootClass" v-bind="$attrs" v-on="$listeners">
    <slot />
  </Component>
</template>

<script>
const VARIANT_VALIDATOR = value =>
  value
    .split(' ')
    .every(variant =>
      [
        '',
        'semibold',
        'subhead',
        'subhead-semibold',
        'body',
        'body-semibold',
        'headline',
        'headline-semibold',
        'caption1',
        'caption2',
        'caption3',
        'caption1-semibold',
        'caption2-semibold',
        'caption3-semibold',
        'header1',
        'header2',
        'header3',
        'header4',
        'header5',
      ].includes(variant),
    );

export default {
  name: 'BravadoText',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    variant: {
      type: String,
      default: '',
      validator: VARIANT_VALIDATOR,
    },
    variantSm: {
      type: String,
      default: '',
      validator: VARIANT_VALIDATOR,
    },
    variantMd: {
      type: String,
      default: '',
      validator: VARIANT_VALIDATOR,
    },
    variantLg: {
      type: String,
      default: '',
      validator: VARIANT_VALIDATOR,
    },
  },
  computed: {
    rootClass() {
      const defaultClass = this.variant.split(' ').map(variant => `bravado-text--${variant}`);
      const smClass = this.variantSm ? this.variantSm.split(' ').map(variant => `bravado-text--sm--${variant}`) : '';
      const mdClass = this.variantMd ? this.variantMd.split(' ').map(variant => `bravado-text--md--${variant}`) : '';
      const lgClass = this.variantLg ? this.variantLg.split(' ').map(variant => `bravado-text--lg--${variant}`) : '';
      return [...defaultClass, ...smClass, ...mdClass, ...lgClass];
    },
  },
};
</script>

<style scoped lang="scss">
$sizes: sm, md, lg;

.bravado-text {
  @mixin typography-variants() {
    &--semibold {
      @include semibold;
    }

    &--subhead {
      @include subhead;
    }

    &--subhead-semibold {
      @include subhead-semibold;
    }

    &--headline {
      @include headline;
    }

    &--headline-semibold {
      @include headline-semibold;
    }

    &--body {
      @include body;
    }

    &--body-semibold {
      @include body-semibold;
    }

    &--caption1 {
      @include caption1;
    }

    &--caption1-semibold {
      @include caption1-semibold;
    }

    &--caption2 {
      @include caption2;
    }

    &--caption2-semibold {
      @include caption2-semibold;
    }

    &--caption3 {
      @include caption3;
    }

    &--caption3-semibold {
      @include caption3-semibold;
    }

    &--hero {
      @include hero;
    }

    &--header1 {
      @include header1;
    }

    &--header2 {
      @include header2;
    }

    &--header3 {
      @include header3;
    }

    &--header4 {
      @include header4;
    }

    &--header5 {
      @include header5;
    }
  }

  @include typography-variants;

  @each $size in $sizes {
    &--#{$size} {
      @include mq('#{$size}') {
        @include typography-variants;
      }
    }
  }
}
</style>
